import Size from '@enums/Size';

const ChipSize = Object.freeze({
  [Size.XX_SMALL]: {
    borderRadius: '2px',
    fontSize: '0.575rem',
    height: '0.925rem',
    lineHeight: '0.925rem',
    pt: 0,
    pl: 0.5,
    pr: 0.5,
  },
  [Size.X_SMALL]: {
    borderRadius: '2px',
    fontSize: '0.7rem',
    height: '1.325rem',
    lineHeight: '1.325rem',
    pt: 0,
    pl: 0.75,
    pr: 0.75,
  },
  [Size.SMALL]: {
    borderRadius: '2px',
    fontSize: '0.75rem',
    height: '1.25rem',
    lineHeight: '1.25rem',
    pt: 0,
    pl: 0.75,
    pr: 0.75,
  },
  [Size.MEDIUM]: {
    borderRadius: '2px',
    fontSize: '0.825rem',
    height: '1.5rem',
    lineHeight: '1.5rem',
    pt: 0,
    pl: 0.75,
    pr: 0.75,
  },
  [Size.LARGE]: {
    borderRadius: '3px',
    fontSize: '0.925rem',
    height: '1.75rem',
    lineHeight: '1.75rem',
    pt: 0,
    pl: 0.75,
    pr: 0.75,
  },
});

export default ChipSize;
